<template>
  <div
    v-if="langs && langs.length > 1"
    class="c-menu-lang-switch"
  >
    <div class="c-menu-lang-switch__title">
      {{ $t('LANG_CHANGE') }}
    </div>
    <ul class="c-menu-lang-switch__wrapper">
      <li v-for="lang in langs" :key="lang.code" class="c-menu-lang-switch__item">
        <input class="c-menu-lang-switch__input u-hidden-visually" name="lang-switch" :id="lang.code" type="radio" :checked="lang.code === selected.code" @input="selectLang(lang)" />
        <label class="c-menu-lang-switch__label" :for="lang.code">
          <span class="c-menu-lang-switch__fake-radio">
            <span v-if="lang.code === selected.code"></span>
          </span>
          {{ lang.label }}
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    langs() {
      return this.$store.getters['appConfig/getAppLangs']
    },

    selected() {
      return this.$store.state.appConfig.currentLocale
    }
  },

  methods: {
    selectLang(ev) {
      this.$store.dispatch('appConfig/setLocale', ev)
    }
  }
}
</script>